import { render, staticRenderFns } from "./ChatBotPersonalDataPolicy.vue?vue&type=template&id=51827bdb"
import script from "./ChatBotPersonalDataPolicy.vue?vue&type=script&lang=js"
export * from "./ChatBotPersonalDataPolicy.vue?vue&type=script&lang=js"
import style0 from "./ChatBotPersonalDataPolicy.vue?vue&type=style&index=0&id=51827bdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports